export default __webpack_public_path__ + "static/media/instructor-1.baa0736b.webp";